export enum StateManagerEvents {
    UPDATE = "UPDATE",
}
